
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSession } from "@supabase/auth-helpers-react";
import { Grid, Users, User, FileText, Building2, Compass, Home } from "lucide-react";

interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
}

export const MobileNav = ({ isOpen, onClose }: MobileNavProps) => {
  const { t } = useTranslation("nav");
  const session = useSession();

  if (!isOpen) return null;

  return (
    <nav className="flex flex-col h-full">
      <div className="flex flex-col space-y-4 pb-6">
        {!session && (
          <Link
            to="/"
            className="flex items-center space-x-2 px-2 py-3 text-lg font-semibold text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted"
            onClick={onClose}
          >
            <Home className="h-5 w-5" />
            <span>{t("home")}</span>
          </Link>
        )}
        
        {session && (
          <>
            <Link
              to="/dashboard"
              className="flex items-center space-x-2 px-2 py-3 text-lg font-semibold text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted"
              onClick={onClose}
            >
              <Grid className="h-5 w-5" />
              <span>{t("dashboard")}</span>
            </Link>
            
            <Link
              to="/profile"
              className="flex items-center space-x-2 px-2 py-3 text-lg font-semibold text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted"
              onClick={onClose}
            >
              <User className="h-5 w-5" />
              <span>{t("profile")}</span>
            </Link>
            
            <Link
              to="/tender-management"
              className="flex items-center space-x-2 px-2 py-3 text-lg font-semibold text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted"
              onClick={onClose}
            >
              <FileText className="h-5 w-5" />
              <span>{t("tenderManagement")}</span>
            </Link>
            
            <Link
              to="/company-information"
              className="flex items-center space-x-2 px-2 py-3 text-lg font-semibold text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted"
              onClick={onClose}
            >
              <Building2 className="h-5 w-5" />
              <span>{t("companyInformation")}</span>
            </Link>
            
            <Link
              to="/competitor-analysis"
              className="flex items-center space-x-2 px-2 py-3 text-lg font-semibold text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted"
              onClick={onClose}
            >
              <Users className="h-5 w-5" />
              <span>{t("competitors")}</span>
            </Link>
            
            <Link
              to="/opportunity-finder"
              className="flex items-center space-x-2 px-2 py-3 text-lg font-semibold text-gray-700 hover:text-primary transition-colors rounded-md hover:bg-muted"
              onClick={onClose}
            >
              <Compass className="h-5 w-5" />
              <span>{t("opportunityFinder")}</span>
            </Link>
          </>
        )}
        
        {/* Removed pricing and about us links */}
      </div>
      
      {/* Removed language selector from the mobile menu */}
      <div className="mt-auto pt-6 border-t">
        {/* Language selector removed, Danish is now the default and only language */}
      </div>
    </nav>
  );
};
